//设置token请求头和content-type
import Axios from "axios";
import Qs from 'qs'
import router from '../../router'
import Vue from 'vue' //为https接口服务
import VueResource from 'vue-resource'//为https接口服务
import { environment } from "../../../config/index";
import store from "@/store/index";
Vue.use(VueResource) //为https接口服务

//设置请求地址
const setHost = (host)=> {
  let urlObj = {
    "0":"https://www.quanyizhan.com",
    "1":"https://www.quanyizhan.cn",
    "2":"http://192.168.155.2:8082",
    "3" : location.origin
  }
  return urlObj[ host || environment ]
}

Vue.prototype.$axios = Axios  //全局注册，使用方法为:this.$axios
Axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
Vue.http.headers.common['token'] = localStorage['token_trade_manage']; //跨域请求添加token

//请求拦截
axios.interceptors.request.use(function (config) {
    config.data = Qs.stringify(config.data);
    config.baseURL = setHost(config.host);
    if (config.formData) {
        var formData = new FormData()
        for (var i in config.formData) {
            formData.append(i, config.formData[i])
        }
        config.headers["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8"
        config.data = formData;
    }
    if (localStorage['token_trade_manage']) {
      config.headers.common['token'] = localStorage['token_trade_manage'];
    }
    return config;
}, function (error) {
  return Promise.reject(error);
});
// 添加一个响应拦截器
Axios.interceptors.response.use(function (response) {
  if (response.data && response.data.code) {
    if(response.data.code == -1 || response.data.code == 0){
      router.replace({ path: "/login" ,query:{ redirect : location.pathname } })
      return response
    }
  }
  return response;
}, function (error) {
  return Promise.reject(error);
})

// 设置全局的url
store.commit('SET_URl',setHost())
Vue.prototype.baseUrl = setHost()


// WEBPACK FOOTER //
// ./src/assets/js/index.js